import {
  SELECT_USE_CASE,
  SET_ALL_USE_CASES,
  ADD_QUESTION_TO_USE_CASE,
  OPEN_DELETE_MODAL,
  CLOSE_DELETE_MODAL,
  SET_SEARCHED_USECASES,
  INFINTIE_USECASES,
} from "../types/usecaseTypes";

const initialState = {
  all: [],
  selected: {
    openDeleteModal: false,
    questions: [
      {
        title: "",
        choices: [{ title: "", weight: null }],
      },
    ],
  },
  totalPages: 0,
  sources: [],
  levels: [],
  infiniteUseCases: [],
};

const useCaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_USE_CASES:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        levels: action.payload.levels,
      };
    case INFINTIE_USECASES:
      return {
        ...state,
        infiniteUseCases: [...state.infiniteUseCases, ...action.payload.items],
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCHED_USECASES:
      return {
        ...state,
        infiniteUseCases: action.payload.items,
        totalPages: action.payload.totalPages,
      };
    case SELECT_USE_CASE:
      return {
        ...state,
        selected: { ...action.payload, openDeleteModal: false },
      };
    case ADD_QUESTION_TO_USE_CASE:
      return {
        ...state,
        selected: {
          ...state.selected,
          questions: [...state.selected.questions, action.payload],
        },
      };
    case OPEN_DELETE_MODAL:
      return {
        ...state,
        selected: { ...state.selected, openDeleteModal: true },
      };
    case CLOSE_DELETE_MODAL:
      return {
        ...state,
        selected: { ...state.selected, openDeleteModal: false },
      };
    default:
      return state;
  }
};

export default useCaseReducer;
